<template>
  <GmapMap
    ref="gmap"
    :zoom="zoom"
    :center="center"
    :options="mapOptions"
    map-type-id="roadmap"
    style="width: 100%; height: 100%"
    v-if="parentInfo.catCd !== 'V'"
  >
    <GmapMarker
      v-if="markerIcon"
      :position="makerLatLng"
      :icon="markerIcon"
      :options="{ optimized: false }"
    />
  </GmapMap>
  <div id="map" :style="mapStyle" v-else-if="parentInfo.catCd === 'V'"></div>
</template>

<script>

import vslScheduleInfo from '@/api/rest/schedule/vslScheduleInfo'

// 지도 위·경도 기본값(서울)
const DEFAULT_LAT = 37.564214
const DEFAULT_LNG = 127.001699

export default {
  name: 'LocationInfo',
  props: {
    parentInfo: {
      type: Object,
      default: function () {
        return {
          // 업무 구분 코드(V=선박위치, P=항구위치)
          catCd: 'V',
          // 선박위치 관련 데이터
          vslCd: '',
          voyNo: '',
          vslNm: '',
          // 항구위치 관련 데이터
          portCd: '',
          // 자체 위,경도 파라미터 사용시
          lttd: '',
          lngtd: ''
        }
      }
     }
  },
  data: function () {
    return {
      // 지도 확대정도
      zoom: this.parentInfo.catCd === 'V' ? 5 : 10,
      // 지도 중앙 위/경도(default - 서울)
      center: { lat: DEFAULT_LAT, lng: DEFAULT_LNG },
      // 아이콘 표시 위/경도(default - 서울)
      makerLatLng: { lat: DEFAULT_LAT, lng: DEFAULT_LNG },
      // 지도 옵션
      mapOptions: {
        minZoom: 3,
        maxZoom: 20
      },
      // 아이콘 옵션 (google.maps.Size/Point 가 필요해 구글 스크립트 로드 후 세팅)
      markerIcon: null,
      containerId: 'map',
      mmsiNo: '',
      token: 'd2c17969-5135-4401-822c-aeedc9262e2e',
      options: {
        display: ['card'],
        cardPosition: { x: 2, y: 5 },
        cardStyle: 1,
        center: { x: 125, y: 25, z: 0 },
        selectedTile: 'LIGHT',
        init: [],
        markers: [],
        vesselColor: 'SOG'
      },
      mapStyle: {
        width: '100%',
        height: '100%',
        overflow: 'hidden'
      }
    }
  },
  mounted () {
    if (this.parentInfo.catCd !== 'V') {
      this.setGoogleMap()
    }
    // 선박 실시간 위치 지도에 표시
    this.getLocationToMap(this.$props.parentInfo)
  },
  methods: {
    async setGoogleMap () {
      // Google Maps 스크립트는 비동기 로드되므로, 완료를 기다린 후 google 전역을 참조한다.
      await this.$gmapApiPromiseLazy()

      // 구글 마커는 원본 크기로 그리고 기준점이 하단 중앙이라 크기·기준점을 지정한다. (marker_red.gif 는 200px 이미지 가운데 점)
      this.markerIcon = {
        url: '/img/marker_red.gif',
        scaledSize: new google.maps.Size(30, 30),
        anchor: new google.maps.Point(15, 15)
      }

      // KMTC 로고는 구글 기본 버튼과 겹치지 않게 지도 컨트롤로 우상단에 붙인다.
      if (!this.$refs.gmap) {
        return
      }
      const map = await this.$refs.gmap.$mapPromise
      const logo = document.createElement('div')
      logo.style.margin = '10px'
      logo.innerHTML = `<img alt="kmtc" src="${require('@/assets/images/schedule/kmtc_logo.gif')}" style="width: 150px; display: block;">`
      map.controls[google.maps.ControlPosition.TOP_RIGHT].push(logo)
    },
    // 위·경도 문자열을 숫자로 바꾼다. 숫자가 아니면 기본값(서울)
    toLatLng (lttd, lngtd) {
      const lat = Number(lttd)
      const lng = Number(lngtd)

      return {
        lat: Number.isNaN(lat) ? DEFAULT_LAT : lat,
        lng: Number.isNaN(lng) ? DEFAULT_LNG : lng
      }
    },
    async getLocationToMap (data) {
      const catCd = data.catCd

      if (catCd === 'V') {
        // 선박 위치 API 호출
        if (globalThis.Oceanlook) {
          this.initOceanlookMap()
        } else {
          console.error('Oceanlook script is not loaded or available.')
          // 필요하다면, 스크립트 로드가 완료될 때까지 기다리는 로직을 추가할 수 있습니다.
        }
      } else if (catCd === 'P') {
        // 항구 위치 API 호출
        await vslScheduleInfo.getPortLocationInfo(data)
          .then(response => {
            console.log(response)
            if (response.status === 200) {
              const resData = response.data

              this.center = this.toLatLng(resData.lttd, resData.lngtd)
              this.makerLatLng = this.toLatLng(resData.lttd, resData.lngtd)
            }
          })
          .catch(error => {
            console.log(error)
          })
      } else if (catCd === 'S') {
        this.center = this.toLatLng(this.parentInfo.lttd, this.parentInfo.lngtd)
        this.makerLatLng = this.toLatLng(this.parentInfo.lttd, this.parentInfo.lngtd)
      }
    },
    // 커스텀 필드 콜백 함수
    customFieldCallback (data) {
      // Return custom fields to display in ship cards
      // ex. fetch additional data from your server based on mmsi or imoNumber
      // data -> {mmsi, imoNumber}
      console.log('customFieldCallback', data)
    },

    // Oceanlook 임베드 초기화
    initOceanlookMap () {
      // Oceanlook의 전역 객체에 접근
      const Oceanlook = globalThis.Oceanlook

      let info = {}
      info.imo = this.parentInfo.imoNo
      info.track = []
      let track = {
        type: 'TIME',
        mode: 'FLOW',
        color: '#000FFF'
      }
      info.track.push(track)
      this.options.init.push(info)

      // Custom field callback function 설정
      Oceanlook.setCustomFieldCallback(this.customFieldCallback)

      // 맵 임베드
      Oceanlook.embed(this.containerId, this.token, this.options)
    }
  }

}
</script>
